/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContactSubmission,
  ContactSubmissionResult,
  ErrorResponse,
  HealthStatus,
  RevealFounderEmailRequest,
  RevealFounderEmailResult
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Verifies the Cloudflare Turnstile token and emails the message via SendGrid.
 * @summary Submit contact form
 */
export const getSubmitContactUrl = () => {




  return `/api/contact`
}

export const submitContact = async (contactSubmission: ContactSubmission, options?: RequestInit): Promise<ContactSubmissionResult> => {

  return customFetch<ContactSubmissionResult>(getSubmitContactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contactSubmission,)
  }
);}




export const getSubmitContactMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactSubmission>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactSubmission>}, TContext> => {

const mutationKey = ['submitContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitContact>>, {data: BodyType<ContactSubmission>}> = (props) => {
          const {data} = props ?? {};

          return  submitContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitContactMutationResult = NonNullable<Awaited<ReturnType<typeof submitContact>>>
    export type SubmitContactMutationBody = BodyType<ContactSubmission>
    export type SubmitContactMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Submit contact form
 */
export const useSubmitContact = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactSubmission>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitContact>>,
        TError,
        {data: BodyType<ContactSubmission>},
        TContext
      > => {
      return useMutation(getSubmitContactMutationOptions(options));
    }

/**
 * Verifies the Cloudflare Turnstile token and, only on success, returns the founder's email address. Keeps addresses out of the client bundle so scrapers that do not solve the challenge never receive them.
 * @summary Reveal a founder's email
 */
export const getRevealFounderEmailUrl = () => {




  return `/api/founder-email`
}

export const revealFounderEmail = async (revealFounderEmailRequest: RevealFounderEmailRequest, options?: RequestInit): Promise<RevealFounderEmailResult> => {

  return customFetch<RevealFounderEmailResult>(getRevealFounderEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      revealFounderEmailRequest,)
  }
);}




export const getRevealFounderEmailMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revealFounderEmail>>, TError,{data: BodyType<RevealFounderEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revealFounderEmail>>, TError,{data: BodyType<RevealFounderEmailRequest>}, TContext> => {

const mutationKey = ['revealFounderEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revealFounderEmail>>, {data: BodyType<RevealFounderEmailRequest>}> = (props) => {
          const {data} = props ?? {};

          return  revealFounderEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevealFounderEmailMutationResult = NonNullable<Awaited<ReturnType<typeof revealFounderEmail>>>
    export type RevealFounderEmailMutationBody = BodyType<RevealFounderEmailRequest>
    export type RevealFounderEmailMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Reveal a founder's email
 */
export const useRevealFounderEmail = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revealFounderEmail>>, TError,{data: BodyType<RevealFounderEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revealFounderEmail>>,
        TError,
        {data: BodyType<RevealFounderEmailRequest>},
        TContext
      > => {
      return useMutation(getRevealFounderEmailMutationOptions(options));
    }

